import { render, staticRenderFns } from "./DataAnalysisNav.vue?vue&type=template&id=875762a4&scoped=true&"
import script from "./DataAnalysisNav.vue?vue&type=script&lang=js&"
export * from "./DataAnalysisNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "875762a4",
  null
  
)

export default component.exports